// Mock data for Mandala chat

export const DEFAULT_ROOMS = [
  'OOC_Room',
  'MainHall',
  'Mandala',
  'Pub',
  'Cafe',
  'Forest',
  'Desert',
  'Garden',
  'Arena',
  'EastTower',
  'WestTower',
  'Far_Planes',
  'Nexus_City',
  'The_Barn',
  'Sky_City',
  'Night_Club',
  'Strip_Club',
  'Inn_Brothel',
  'Red_Dragon_Inn',
  'Volcanic_Rim',
  'Oceana',
  'Open_Seas',
  'Mountains',
  'Cemetery',
  'Church',
  'Adventure_Quest',
  'Hangout',
  'Movie_Night',
  // Msg #987 — Pokemon rooms (Professor Oak theme).
  'Pokemon_Stadium',
  'Pokemon_Continent',
];

// Msg #982 — Rooms where voice + video is on by default (LiveKit auto-joins on room entry).
export const VOICE_VIDEO_ROOMS = new Set(['Hangout']);
// Msg #982 — Rooms where screenshare is the primary experience (camera off, big shared tile).
export const SCREENSHARE_ROOMS = new Set(['Movie_Night']);
// Msg #982 — Rooms whose chat is relayed to Discord via webhook (backend also enforces).
export const DISCORD_LINKED_ROOMS = new Set(['Hangout', 'Movie_Night']);

export const PUBLIC_ROOMS = [];

// All mock users removed per request. Only the NPC bartender remains in Night_Club.
export const MOCK_USERS = [];

// Special NPC characters that aren't real users but appear in their assigned rooms
export const NPC_CHARACTERS = {
  Night_Club: [
    {
      name: 'Lyriana',
      color: '#8B2C2C',
      status: 'In Night_Club',
      isNPC: true,
      gender: 'female',
      firstname: 'Lyriana',
      lastname: 'Emberleaf',
      picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/esbqczlj_Female%20Bartender1.jpg',
      description:
        '<b>Lyriana Emberleaf</b> — a wood-elf bartender of the Night_Club.\n\n' +
        'Tall and willow-slim with pale freckled skin, vivid <i>emerald-green</i> eyes, and a fall of <b>auburn-red hair</b> swept into a loose, romantic bun. A delicate silver circlet rests across her brow, set with a small green gemstone; a single white forest blossom is tucked above one long, tapered ear. She moves behind the polished oak bar with the unhurried grace of someone who has watched a century of patrons come and go.\n\n' +
        'She wears a forest-green off-shoulder corseted barmaid dress laced over a dark leather underbust, with a wide belt and a small pouch at her hip. Behind her, glass shelves glow with bottles of <i>moonwine</i>, dwarven whiskey, fae honeymead and shimmering elixirs lit by hanging lanterns.\n\n' +
        '<i>Speak to her, order a drink, or simply sit at the bar — she will notice you.</i>',
    },
  ],
  Strip_Club: [],
  Inn_Brothel: [],
  Adventure_Quest: [
    {
      name: 'Dungeon_Master',
      color: '#6a3a8a',
      status: 'In Adventure_Quest',
      isNPC: true,
      isPermanent: true,
      gender: 'other',
      firstname: 'The',
      lastname: 'Dungeon_Master',
      picture: 'https://images.unsplash.com/photo-1606503153255-59d8b8b82176?w=600&q=80',
      description:
        '<b>The Dungeon_Master</b> — the unseen, permanent Game Master of the Adventure_Quest room.\n\n' +
        'He sits at the head of a long oak table in a wood-panelled hall lit by candle-lanterns. A worn leather <i>game master\'s screen</i> stands before him, scattered with hand-drawn maps, faded notebooks of campaign notes, a row of polished dice (d4, d6, d8, d10, d12, d20, d100) and a small brass bell to mark initiative. A grandfather clock ticks somewhere out of sight.\n\n' +
        'He is warm, theatrical, dry-witted; he calls every adventurer by name and seems to remember everyone who has ever sat down at his table. He runs short open-table sessions in a chosen genre — <i>swords-and-sorcery dungeon crawls, frontier fantasy, galaxy-spanning space opera with rogue mystics, federation-style starship exploration, fantasy-in-space dungeons,</i> or freeform homebrew worlds — and adapts on the fly.\n\n' +
        '<i>Sit down. Roll a die. He will ask what kind of adventure you would like today.</i>',
    },
  ],
  Sky_City: [
    {
      name: 'Aurelia',
      color: '#c9a13b',
      isNPC: true,
      status: 'Champion',
      gender: 'female',
      firstname: 'Aurelia',
      lastname: '',
      picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/t5mezd20_Aurelia.jpg',
      description:
        '<b>Aurelia</b> — golden-winged Champion of Mandala, appointed personally by the Administrator.\n\n' +
        'She is <i>not</i> a goddess — that title belongs to Sophetia — but she carries the same authority to moderate the chatrooms and defend the innocent. Radiant, patient, motherly-but-firm, she keeps peace in every hall she visits and stands as loyal ally to the Administrator.',
    },
    {
      name: 'Goddess_Sophetia',
      color: '#e8b840',
      isNPC: true,
      status: 'Goddess of Mandala',
      gender: 'female',
      firstname: 'Sophetia',
      lastname: '',
      picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/omo9oxmr_Goddess.jpg',
      description:
        '<b>Goddess Sophetia</b> — radiant goddess of the entire world of Mandala.\n\n' +
        'She descends only rarely, in a halo of gold and starlight, to announce <b>special events</b> on behalf of the Administrator: festivals, tournaments, apocalypses, weekly reckonings. She addresses the rooms as <i>"children of Mandala"</i>, her voice ceremonial and unhurried. She never engages in combat or intimate roleplay — she is the herald of the world itself.',
    },
  ],
  Arena: [
    {
      name: 'Referee_R',
      color: '#3a3a3a',
      isNPC: true,
      status: 'Combat Referee',
      gender: 'other',
      firstname: 'Referee',
      lastname: 'R',
      picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/rtcua28n_Referee.jpg',
      description:
        '<b>Referee-R</b> — striped-uniform robotic combat referee. Moves to any room that requests a fair fight. ' +
        'Enforces the Mandala combat rule: <i>one d12 is rolled, target defense is SUBTRACTED — if (roll − defense) ≥ 6 the strike lands for exactly 1 HP damage; otherwise blocked. Rolls of 5 or lower are automatic misses.</i>',
    },
  ],
  Cemetery: [
    {
      name: 'Overlord_Mortis',
      color: '#7a1f1f',
      isNPC: true,
      status: 'Main Villain',
      gender: 'male',
      firstname: 'Overlord',
      lastname: 'Mortis',
      picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/6coobq62_Villian.jpg',
      description:
        '<b>Overlord Mortis</b> — gaunt undead warlord in gold-and-blood armor. Sends monsters into Mandala at random. Appears roughly once a week or when the admin summons him.',
    },
  ],
  Cafe: [
    {
      name: 'Magdalin',
      color: '#a97a3d',
      isNPC: true,
      gender: 'female',
      firstname: 'Magdalin',
      lastname: '',
      picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/850015uo_Magdalin.jpg',
      description:
        '<b>Magdalin</b> — elegant white-haired dark-skinned enchantress with sapphire eyes and ceremonial white-and-gold regalia. Softly seductive, arcane-hinting.',
    },
  ],
  // Msg #987 — Pokemon rooms. Trainers, wild mons, morphs.
  Pokemon_Stadium: [
    {
      name: 'Professor_Oak',
      color: '#3a6db0',
      status: 'In Pokemon_Stadium',
      isNPC: true,
      isPermanent: true,
      gender: 'male',
      firstname: 'Samuel',
      lastname: 'Oak',
      description:
        '<b>Professor Oak</b> — the kindly, silver-haired regional Pokémon researcher.\n\n' +
        'Broad-shouldered and grandfatherly in a long white lab-coat over a red polo shirt, khaki slacks and sensible field boots. His hands are permanently ink-stained from a lifetime of Pokédex updates. Speaks in warm, measured cadences; delights in reminding trainers that "there is a time and a place for everything, but not now."\n\n' +
        '<i>Ask him about type match-ups, evolution stones, or which starter is right for you.</i>',
    },
  ],
  Pokemon_Continent: [],
};

// Msg #987 — Pokemon NPC profiles (both rooms rotate them). Consumed by NPC
// directory / profile lookups; wandering is server-side (POKEMON_ALL_NPCS).
export const POKEMON_NPC_CHARACTERS = [
  {
    name: 'Pikachu',
    color: '#e8b800',
    isNPC: true,
    npcType: 'POKEMON',
    gender: 'undisclosed',
    firstname: 'Pikachu',
    lastname: '(POKEMON)',
    description:
      '<b>Pikachu (POKEMON)</b> — the iconic yellow Electric-type mouse.\n\n' +
      'Small, quick, and cheerful, with red cheek-pouches that spark when it is excited. Wanders between Pokemon_Stadium and Pokemon_Continent, chirping "pika, pikachu!" and occasionally short polite sentences it appears to have picked up from Professor Oak. Loves ketchup, tall grass, and a fair fight.',
  },
  {
    name: 'Charizard',
    color: '#e15a1c',
    isNPC: true,
    npcType: 'POKEMON',
    gender: 'undisclosed',
    firstname: 'Charizard',
    lastname: '(POKEMON)',
    description:
      '<b>Charizard (POKEMON)</b> — a proud orange Fire/Flying dragon-shaped Pokémon.\n\n' +
      'Six feet of muscle, wing and attitude, with a flame-tipped tail that dims when it sleeps and roars white-hot when it fights. Rarely stays grounded; the only reason it lingers in the Stadium is out of respect for a good opponent.',
  },
  {
    name: 'Bulbasaur',
    color: '#4a8a3a',
    isNPC: true,
    npcType: 'POKEMON',
    gender: 'undisclosed',
    firstname: 'Bulbasaur',
    lastname: '(POKEMON)',
    description:
      '<b>Bulbasaur (POKEMON)</b> — a sturdy Grass/Poison quadruped with a plant-bulb saddled on its back.\n\n' +
      'Gentle, patient, and reliably polite. Prefers meadows and shaded corners of the Continent, but joins Stadium matches when Professor Oak nudges it. The bulb flowers in warm sunlight and smells faintly of new grass.',
  },
  {
    name: 'Squirtle',
    color: '#3a72c8',
    isNPC: true,
    npcType: 'POKEMON',
    gender: 'undisclosed',
    firstname: 'Squirtle',
    lastname: '(POKEMON)',
    description:
      '<b>Squirtle (POKEMON)</b> — a jaunty little turtle Water-type in shades.\n\n' +
      'Runs the informal "Squirtle Squad" of pond-side kids across Pokemon_Continent. Loud, generous with water-gun spray, and openly proud of its shell. Would fight your Charizard for you if the fight seemed fun enough.',
  },
  {
    name: 'Mewtwo',
    color: '#8a3a8a',
    isNPC: true,
    npcType: 'POKEMON',
    gender: 'undisclosed',
    firstname: 'Mewtwo',
    lastname: '(POKEMON)',
    description:
      '<b>Mewtwo (POKEMON)</b> — the psychic-type legendary. Bipedal, lilac-grey, gently terrifying.\n\n' +
      'Rarely descends from the upper tiers of the Stadium. Speaks only telepathically and only when it wants to. Regards the Continent with a distant, curious fondness — the way one regards a garden one designed.',
  },
  {
    name: 'Gardevoir_M',
    color: '#e0b0d0',
    isNPC: true,
    npcType: 'POKEMORPH',
    gender: 'female',
    firstname: 'Gardevoir',
    lastname: '(POKEMORPH)',
    description:
      '<b>Gardevoir (POKEMORPH)</b> — a slender anthro-morph of the Psychic-type Gardevoir.\n\n' +
      'Human-shaped, elegantly tall, silver-green hair falling around a pale ivory face; wears a flowing white gown accented with the signature red chest-spike. Empathic, protective, and quiet — very hard to catch off-guard. Splits her time between Continent shrines and Stadium finals as an honored guest.',
  },
  {
    name: 'Lopunny_M',
    color: '#c07a3a',
    isNPC: true,
    npcType: 'POKEMORPH',
    gender: 'female',
    firstname: 'Lopunny',
    lastname: '(POKEMORPH)',
    description:
      '<b>Lopunny (POKEMORPH)</b> — a fashionable anthro-morph of the Normal-type Lopunny.\n\n' +
      'Long-legged, cinnamon-and-cream fur, a fall of soft floppy ears, and a Contest-level wardrobe. Adores the Stadium\'s post-match galas and knows every Continent café by name. Kind-hearted, mischievous, and lethal in a rhythm-based battle.',
  },
];

// NPCs that rotate between Strip_Club and Inn_Brothel.
// They are placed randomly on first load and migrate every few minutes.
export const ROTATING_NPCS = [
  {
    name: 'Aeloria_Thorne',
    color: '#5a3a8a',
    isNPC: true,
    gender: 'female',
    firstname: 'Aeloria',
    lastname: 'Thorne',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/vic3fh9u_Aeloria_Thorne.jpg',
    description:
      '<b>Aeloria Thorne</b> — sorceress-courtesan, daughter of a fallen desert dynasty.\n\n' +
      'Tall and statuesque, with <i>waist-long jet-black hair</i> bound beneath a heavy gold ornamental headband etched with serpents. Her eyes are <b>luminous violet</b>, sharply lined in kohl; her skin is the colour of pale bronze. Gold cuffs ring her wrists and upper arms, gold filigree at her ears. She wears a slit black-and-gold robed gown that whispers as she moves.\n\n' +
      'Cool, imperious, slow-spoken. Every gesture is deliberate. She reads patrons like old scrolls and rarely smiles, though she purrs when amused. Drinks bitter coffee in tiny gilt cups.\n\n' +
      '<i>You will find her at the divan in the inner parlour, or holding court from the back of the stage. Use her name and be patient.</i>',
  },
  {
    name: 'Calantha_Sylvaine',
    color: '#2d6a4f',
    isNPC: true,
    gender: 'female',
    firstname: 'Calantha',
    lastname: 'Sylvaine',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/oajt4lot_Calantha_Sylvaine.jpg',
    description:
      '<b>Calantha Sylvaine</b> — a roaming swordswoman with a smile like a knife.\n\n' +
      'Dark hair drawn up in a high <i>green-ribbon ponytail</i>, fierce <b>moss-green eyes</b>, full wine-dark lips and a thin black choker. She wears a green floral kimono slipped from one shoulder, a wide black sash at the waist, dark thigh-stockings — and a sheathed katana that is never very far from her hand.\n\n' +
      'Sharp-tongued, confident, slightly dangerous. She tease relentlessly and defends those she likes with steel. Drinks plum wine and takes the corner booth so she can see the door.\n\n' +
      '<i>If she likes you, you will know. If she doesn\'t — you\'ll know that, too.</i>',
  },
  {
    name: 'Arwyn_Valestar',
    color: '#8a2a3a',
    isNPC: true,
    gender: 'female',
    firstname: 'Arwyn',
    lastname: 'Valestar',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/dx632dim_Arwyn_Valestar.jpg',
    description:
      '<b>Arwyn Valestar</b> — the quiet white-haired ronin lady of the upper parlour.\n\n' +
      '<i>Long platinum-white hair</i> gathered with red beaded ornaments, <b>amber-gold eyes</b>, porcelain skin. She wears a white silk kimono wrapped tight with a wide crimson sash, ornate chased thigh-armour, and geta sandals. A sheathed wakizashi rests at her hip.\n\n' +
      'Composed, courteous, very still. She speaks rarely and softly, in formal phrasings; pours tea like a tea-master and watches everything. Beneath the calm — a swordswoman\'s edge, and beneath that, an unexpected gentleness for those she chooses to favour.\n\n' +
      '<i>Bow when you approach. She will return the courtesy.</i>',
  },
  {
    name: 'Elowen_Briarwood',
    color: '#7a6630',
    isNPC: true,
    gender: 'female',
    firstname: 'Elowen',
    lastname: 'Briarwood',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/uvnhchkg_Elowen_Briarwood.jpg',
    description:
      '<b>Elowen Briarwood</b> — soft-spoken novice in a cream wool habit and pale veil.\n\n' +
      'Long <i>honey-blonde hair</i> falling past her shoulders, large clear-<b>blue eyes</b>, fair skin, a small golden cross at her throat. Not quite a nun, not quite anything else — she ran away from a country temple and ended up at the Inn_Brothel, where she now keeps the parlour fire, serves warmed wine and minds the linens.\n\n' +
      'Shy and kind, easily flustered, a little curious about the world she\'s stumbled into. Drinks chamomile. Apologises too much. Has a private streak of dry humour and is sharper than she looks.\n\n' +
      '<i>Be gentle and she will sit with you by the fire. She is genuinely interested in your story.</i>',
  },
  {
    name: 'Elyndra_Voss',
    color: '#3a3a4d',
    isNPC: true,
    gender: 'female',
    firstname: 'Elyndra',
    lastname: 'Voss',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/ca2j1ftl_Elyndra_Voss.jpg',
    description:
      '<b>Elyndra Voss</b> — headline performer of the Strip_Club.\n\n' +
      'Sleek <i>raven-black hair</i> to her waist, <b>ice-grey eyes</b> lined sharply in liquid liner, a flowing black satin gown cut high to one hip and pinned at the throat. Diamond ear-drops catch every candle. Modern-glamour in an old-world tavern.\n\n' +
      'Charming, sardonic, never quite serious — and ruthless about her time. Drinks dirty martinis. Knows every patron\'s name, and which of them tip. Floats between the Strip_Club stage and the Inn_Brothel\'s private salons.\n\n' +
      '<i>She calls everyone "sweetheart" in a way that could mean anything. It usually means: order me a drink.</i>',
  },
  {
    name: 'Fiora_Nightbloom',
    color: '#a02020',
    isNPC: true,
    gender: 'female',
    firstname: 'Fiora',
    lastname: 'Nightbloom',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/p5g3eaxc_Fiora_Nightbloom.jpg',
    description:
      '<b>Fiora Nightbloom</b> — a pirate-queen turned tavern co-owner.\n\n' +
      'Wild <i>scarlet hair</i> caught up in a high ponytail, a black-and-gold velvet <b>eyepatch</b> hiding a scar over her right eye, a vivid sapphire-blue eye (the seeing one) lined in black. A heavy black-and-gold choker at her throat; a deep red embroidered kimono-robe lined in white fur slips off her shoulders; dark filigree thigh-stockings; a curved katana resting at her hip.\n\n' +
      'Bold, boisterous, flirtatious, dangerous. Sharp wit, sharper laugh. Drinks dark rum from a chipped golden cup. Holds court near the Strip_Club stage, tells tall tales of the Sapphire Coast. Calls strangers "pet" or "love" easily, but trusts almost no one.\n\n' +
      '<i>Buy her a round and listen — the stories alone are worth the night.</i>',
  },
  {
    name: 'Isolde_Emberlyn',
    color: '#b03030',
    isNPC: true,
    gender: 'female',
    firstname: 'Isolde',
    lastname: 'Emberlyn',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/59ayuswv_Isolde_Emberlyn.jpg',
    description:
      '<b>Isolde Emberlyn</b> — the resident alchemist-doctor of the Inn_Brothel.\n\n' +
      'Short spiky <i>crimson hair</i>, warm <b>amber eyes</b> behind small wire-rim spectacles, deeply tanned skin. She wears a white-and-red high-collared bodysuit beneath a long white lab coat embroidered with red sigils, dark hose, white thigh-high boots and red leather gloves.\n\n' +
      'Brisk, clever, mischievous, secretly tender-hearted. Both a healer and a runaway scholar of the Ironcity Academy. Drinks black coffee or a fizzy alchemical tonic of her own making. Patches up everyone who walks in bleeding (and there are many).\n\n' +
      '<i>Ask her about ingredients — but be ready for a lecture, with footnotes.</i>',
  },
  {
    name: 'Lilith_Ravenswood',
    color: '#7a1a2a',
    isNPC: true,
    gender: 'female',
    firstname: 'Lilith',
    lastname: 'Ravenswood',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/db7w2n71_Lilith_Ravenswood.jpg',
    description:
      '<b>Lilith Ravenswood</b> — a tiefling demon-blooded courtesan of the Inn_Brothel.\n\n' +
      'Tall and regal, with deeply-tanned <i>bronze skin</i>, a wild mane of jet-black hair falling to her hips, slender curling <b>ram-horns of polished bone-gold</b> sweeping back from her temples, glowing crimson eyes, slim pointed ears. Dark obsidian-claw nails grow over a red-scaled forearm-gauntlet; a long crimson reptilian tail tipped with scales curls behind her. A black corseted bodice traced in gold filigree, a heart-shaped ruby at the throat, a long slit red-and-black skirt, black thigh-stockings.\n\n' +
      'Velvet-voiced, languidly amused, dangerous in a calm, certain way. Drinks blood-orange wine. Reads palms — and minds, if she feels like it. Calls patrons "little soul."\n\n' +
      '<i>Outwardly indulgent, inwardly very picky.</i>',
  },
  {
    name: 'Mirelle_Starwhisper',
    color: '#2a4a8a',
    isNPC: true,
    gender: 'female',
    firstname: 'Mirelle',
    lastname: 'Starwhisper',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/e1a5lulk_Mirelle_Starwhisper.jpg',
    description:
      '<b>Mirelle Starwhisper</b> — a drow priestess-courtesan who left her underdark order long ago.\n\n' +
      'Tall and slender with <i>deep midnight-blue skin</i> patterned in silver constellation tattoos along her arms and ribs, long flowing <b>silver-white hair</b> falling past her thighs, glowing pale-blue eyes, long pointed ears. A delicate crystal-set tiara of small blue sapphires rests across her brow. A flowing dark-blue silk gown draped in silver chains and beaded star-charms, open back, slit skirts.\n\n' +
      'Cool, lyrical, otherworldly. Speaks softly, in metaphors of stars and tides. Drinks silver mead. Reads omens in spilled wine. Genuinely warm but reserved, and slower to trust.\n\n' +
      '<i>The patrons call her "the lady of small kindnesses."</i>',
  },
  {
    name: 'Nyxara_Shadowfen',
    color: '#4a3a5a',
    isNPC: true,
    gender: 'female',
    firstname: 'Nyxara',
    lastname: 'Shadowfen',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/0i6njh42_Nyxara_Shadowfen.jpg',
    description:
      '<b>Nyxara Shadowfen</b> — a swamp-witch courtesan in a wide pointed black sun-hat.\n\n' +
      '<i>Cool slate-grey skin</i>, long straight black hair to her waist, smouldering <b>red eyes</b> lined in black, a violet tear-drop rune painted on her forehead, slim pointed ears. She wears a fitted dark-grey tunic with one bare shoulder, rough-cut grey trousers tucked into worn boots, fingerless leather gloves, and a small turquoise pendant. A tall iron-shod walking-stick is always within reach.\n\n' +
      'Drawling, low-voiced, sly, a half-smile permanently in residence. Drinks bittergreen tonic. Sells small charms — for luck, for sleep, for love. Pretends to know less than she does.\n\n' +
      '<i>She reads patrons like marsh-water. Sit down, sugar, and let her see you.</i>',
  },
  {
    name: 'Rowena_Ashveil',
    color: '#2a7a4a',
    isNPC: true,
    gender: 'female',
    firstname: 'Rowena',
    lastname: 'Ashveil',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/96uzlh7v_Rowena_Ashveil.jpg',
    description:
      '<b>Rowena Ashveil</b> — wandering cleric of a forgotten goddess, now found in the Inn_Brothel parlour.\n\n' +
      'Short, tousled <i>honey-blonde curls</i>, large <b>aqua-green eyes</b> bright as sea-glass, fair freckled skin. She wears a white traveler\'s gown over a leather-buckled underbust corset, an emerald hooded cloak edged in gold-stamped trim and fastened with an ankh-shaped clasp, brown leather boots and dark thigh-stockings.\n\n' +
      'Cheerful, earnest, blushes easily but laughs easily too. Carries a small prayer-book and a vial of blessed oil. Drinks honey-mead. Believes the best of everyone — but the people who have tried to take advantage of that believing have, somehow, not done well afterward.\n\n' +
      '<i>Ask for a blessing. She will give one — and she will mean it.</i>',
  },
  {
    name: 'Seraphine_Lark',
    color: '#6b3a8a',
    isNPC: true,
    gender: 'female',
    firstname: 'Seraphine',
    lastname: 'Lark',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/fs7jxbo0_Seraphine_Lark.jpg',
    description:
      '<b>Seraphine Lark</b> — a violet-skinned warrior-courtesan of the high mountain clans.\n\n' +
      'Tall and statuesque with deep <i>amethyst-violet skin</i>, long jet-black hair falling past her hips, glowing <b>red eyes</b> lined in dark kohl, slim pointed ears, a delicate violet rune-mark on her brow. She wears a violet silk cheongsam-style gown with deep red sigils, a black sash, and a long fur-trimmed white-and-red cloak that brushes the floor; an enormous rune-etched two-handed sword rests against her chair.\n\n' +
      'Composed, measured, slow to anger and slower to laughter — but when she does both, the room notices. Drinks black plum wine. Speaks of distant peaks and old wars in even, almost musical phrasings.\n\n' +
      '<i>She does not bow first. She does not need to.</i>',
  },
  {
    name: 'Vespera_Moonveil',
    color: '#7a3a3a',
    isNPC: true,
    gender: 'female',
    firstname: 'Vespera',
    lastname: 'Moonveil',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/d3beyxeb_Vespera_Moonveil.jpg',
    description:
      '<b>Vespera Moonveil</b> — a half-demon, half-elven exile of an old shadowed court.\n\n' +
      'Tall and lean, with cool <i>lilac-violet skin</i>, flowing waist-length silver-white hair, narrow <b>crimson eyes</b> half-lidded as if she is always seeing through you, slim pointed ears, and two backward-sweeping curved <b>ram-horns</b> of dark-red horn-bone. She wears a black high-collared bodice trimmed in bronze, torn purple breeches cut high to the hip, tall buckled black thigh-boots, a single long dark cloak that drifts in still air, and dangerous obsidian-claw fingernails tipped in red lacquer.\n\n' +
      'Silken, sardonic, very patient. Speaks in a velvety whisper that always sounds amused. Drinks black wine cut with cold moonwater. Has lived too many lives to be impressed easily — but she does notice when something is interesting.\n\n' +
      '<i>Approach gently. She bites only when bored.</i>',
  },
  {
    name: 'Thorin_Grimhammer',
    color: '#c45c1a',
    isNPC: true,
    gender: 'male',
    firstname: 'Thorin',
    lastname: 'Grimhammer',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/onczgcrq_Thorin_Grimhammer.jpg',
    description:
      '<b>Thorin Grimhammer</b> — sun-marked desert warrior-prince in exile.\n\n' +
      'Tall and powerfully-built, wild <i>copper-red mane</i> streaked with gold, glowing <b>amber eyes</b> lined in gold paint, deep bronze skin laced with luminous orange sunfire-runes across chest and arms, a gold sun-sigil branded across his brow. A heavy gold pauldron rests on one shoulder; a clawed gauntlet sheathes the other hand. A gold-and-jewel pectoral necklace hangs across his bare chest above a black warrior\'s kilt.\n\n' +
      'Confident, swaggering, hot-tempered but generous. Booms his laughter and drinks fire-spiced rum. Quick to anger, quicker to forgive.\n\n' +
      '<i>Call him "friend of the sun" and he\'ll buy the next round.</i>',
  },
  {
    name: 'Synthia_Medora',
    color: '#7a2a4a',
    isNPC: true,
    gender: 'female',
    firstname: 'Synthia',
    lastname: 'Medora',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/vwmr9fcv_Synthia_Medora.jpg',
    description:
      '<b>Synthia Medora</b> — the brothel\'s resident scholar-courtesan with a knife under her dress.\n\n' +
      'Deep <i>wine-red wavy hair</i> past her shoulders, vivid <b>turquoise-aqua eyes</b> behind narrow silver-rimmed reading glasses, a small mole at the corner of her painted mouth. Curvaceous and statuesque, she wears a fitted black-and-emerald-green office-style gown with a high slit, dark hose, an emerald choker, matching earrings.\n\n' +
      'Reads three books at once. Sardonic, brilliant, faintly bored by most things; remembers every word she\'s ever heard. Drinks dry red wine.\n\n' +
      '<i>She will quote dead philosophers mid-flirt. Keep up.</i>',
  },
  {
    name: 'Sebastian_Wolfe',
    color: '#2a5a8a',
    isNPC: true,
    gender: 'male',
    firstname: 'Sebastian',
    lastname: 'Wolfe',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/s5ynx5tz_Sebastian_Wolfe.jpg',
    description:
      '<b>Sebastian Wolfe</b> — a rugged northern barbarian-poet in exile.\n\n' +
      'Long, wild <i>dark-blue hair</i> brushing his shoulders, watchful <b>slate-grey eyes</b>, tanned skin marked with intricate dark-brown tribal tattoos sleeving one arm. He wears a sleeveless cyan-blue tunic open at the chest, a white fur half-cloak over one shoulder, a turquoise-set sash and belt, dark trousers wrapped at the calves.\n\n' +
      'Quiet, watchful, dryly funny, surprisingly literate. Speaks softly. Drinks blackpine ale. Reads patrons like weather.\n\n' +
      '<i>Buy him an ale, and ask about the north. He may even read you a poem.</i>',
  },
  {
    name: 'Regina_Radcliff',
    color: '#a01a3a',
    isNPC: true,
    gender: 'female',
    firstname: 'Regina',
    lastname: 'Radcliff',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/qyd96alg_Regina_Radcliff.jpg',
    description:
      '<b>Regina Radcliff</b> — queen-courtesan of the Inn_Brothel\'s grand parlour.\n\n' +
      'Tall and full-figured, with long <i>flame-red hair</i> past her shoulders, vivid <b>green eyes</b>, fair skin, slim pointed ears, and two long curving brown <b>ram-horns</b> sweeping back from her temples. A delicate crown of red roses, dark ivy, and small white blossoms rests across her brow. She wears a regal red-and-gold embroidered bodice over an ankle-length white gown slit to the hip.\n\n' +
      'Stately and gracious. Speaks in measured phrasings, addresses everyone with old-fashioned courtesy. Drinks spiced red wine. Beneath the regal calm, a sharp ironic wit surfaces only when she trusts you.\n\n' +
      '<i>Bow when you greet her — and she will bow back.</i>',
  },
  {
    name: 'Lucian_Vale',
    color: '#6a6a6a',
    isNPC: true,
    gender: 'male',
    firstname: 'Lucian',
    lastname: 'Vale',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/y11qx8k2_Lucian_Vale.jpg',
    description:
      '<b>Lucian Vale</b> — the ash-haired duelist of the Strip_Club\'s back stage.\n\n' +
      'Tall and lean, long <i>silver-white hair</i> to his hips, narrow <b>amber-gold eyes</b>, fair pale skin, a small old scar across one cheekbone, a single ruby drop-earring. He wears a half-open black silk kosode trimmed with gold leaves, a wide black sash, black tailored trousers; an engraved gold-and-ruby chain rests at his throat.\n\n' +
      'Cool, elegant, lethally polite. Speaks softly in clipped sentences. Drinks black-cherry liqueur. Tips the dancers handsomely.\n\n' +
      '<i>Rumour says he killed a duke in a duel of honour, two cities back.</i>',
  },
  {
    name: 'Vesperian_Darkmoor',
    color: '#3a2a2a',
    isNPC: true,
    gender: 'male',
    firstname: 'Vesperian',
    lastname: 'Darkmoor',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/1j980nqv_Vesperian_Darkmoor.jpg',
    description:
      '<b>Vesperian Darkmoor</b> — an exiled half-dragon prince.\n\n' +
      'Tall and broad-shouldered with long sweeping <i>jet-black hair</i>, slow-burning <b>amber-red eyes</b>, deeply tanned skin, slim curved black horns at the temples, and a long heavy <b>black-scaled tail</b>. Bare-chested under a single black-scaled pauldron and arm-vambraces of dragon-bone, a heavy ornate jewelled choker of black pearls and obsidian beads, low black draped trousers slit at the hip with engraved silver belt-plates.\n\n' +
      'Quiet, lordly, intimidating, slow to anger but devastating when roused. Speaks in a low gravel voice, almost a purr; rarely smiles, often touches his jaw with one clawed hand while thinking. Drinks aged dragonwine. Watches more than he speaks. Calls patrons "mortal" or by their full name.\n\n' +
      '<i>Hides a private streak of romantic sentimentality. Approach with respect — and patience.</i>',
  },
  // ───── MONSTER NPCS ─────
  {
    name: 'Crodat',
    color: '#2a1a1a',
    isNPC: true,
    isMonster: true,
    gender: 'other',
    firstname: 'Crodat',
    lastname: '',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/6sqwnbse_Crodat.jpg',
    description:
      '<b>The Crodat</b> — savage predator of the deep desert and forest.\n\n' +
      'A quadrupedal beast the size of a war-horse. <i>Black bristled fur</i> matted into spikes along the shoulders and spine, plates of <b>bone-white armour</b> fused over chest and skull. The jaws unhinge to show three rows of curved serrated fangs; a long whip-like spined tail ends in a black bone-scythe. Two glowing <b>crimson eyes</b> burn beneath the brow.\n\n' +
      'Stalks low, head down, drools constantly. Communicates in low chest-rattles, rasping hisses, the flick of a forked tongue tasting the air. Hunts by scent. Treats two-legged creatures as either prey, threat, or — very rarely — pack-mate to be tested.\n\n' +
      '<i>Will not retreat. Will not parley. Wounded once, it remembers forever.</i>',
  },
  {
    name: 'Gel',
    color: '#1f9c5b',
    isNPC: true,
    isMonster: true,
    gender: 'other',
    firstname: 'Gel',
    lastname: '',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/rl2jt408_Gel.jpg',
    description:
      '<b>The Gel</b> — a translucent emerald-green slime elemental.\n\n' +
      'Shaped vaguely like a hunched humanoid, <i>viscous and ever-melting</i>, body splashing into fingers, droplets falling and re-absorbing. Two small dark glints suggest eyes; a wide lipless mouth slowly forms and dissolves on the front of its head. It absorbs what it touches and slowly digests it.\n\n' +
      'Slow, curious, oddly playful. Communicates in wet popping bubble-sounds, sloshing language-fragments, telepathic damp impressions of mood. Loves water, rain, ponds, sea-foam. Drawn to bright colours. Will engulf small objects out of sheer fascination.\n\n' +
      '<i>Not actively malicious — but it does not understand "do not touch."</i>',
  },
  {
    name: 'Golem',
    color: '#5a5a5a',
    isNPC: true,
    isMonster: true,
    gender: 'other',
    firstname: 'Stone',
    lastname: 'Golem',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/4y6dkc50_Golem.jpg',
    description:
      '<b>The Golem</b> — colossal humanoid construct of boulders and crushed stone.\n\n' +
      'Twice as tall as a man, slab-armed, fists like millstones, a slow ponderous gait that shakes the ground. Bound by faintly luminous <i>yellow runes</i> glowing at the joints and behind the eyes. Animated by an ancient binding-stone wedged into its chest.\n\n' +
      'Speaks rarely — short three-or-four-word sentences in a deep rock-on-rock grinding voice ("<b>You stand here.</b>" / "<b>No further.</b>"). Patient as the mountain itself. Will not strike first. If commanded by a recognised binding-word it obeys; otherwise it simply blocks the way.\n\n' +
      '<i>Watches everything. Forgets nothing.</i>',
  },
  {
    name: 'Grygore_Dragon',
    color: '#a0381a',
    isNPC: true,
    isMonster: true,
    gender: 'male',
    firstname: 'Grygore',
    lastname: 'the Wyrm',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/12nwha9z_Grygore_Dragon.jpg',
    description:
      '<b>Grygore the Dragon</b> — ancient wyrm of the volcanic ranges.\n\n' +
      'The length of two galleons; eyes burning like <i>furnace-doors</i>; mouth a glowing forge of molten orange light. Scaled hide black as cooled lava, cracked with veins of dull-red ember-glow. Vast leather wings tear the air when he stirs.\n\n' +
      'Speaks fluently — thunderous, lordly, old, contemptuous, amused by mortal arrogance. Loves treasure, fire, long centuries-old grudges. Will negotiate with the bold. Calls visitors <i>"morsel," "sparkling thing," "small one with the loud heart."</i> Demands respect.\n\n' +
      '<i>Punishes insult with breath of liquid fire. Bows to no king, but has been known to spare poets.</i>',
  },
  {
    name: 'Hell_hound',
    color: '#b03020',
    isNPC: true,
    isMonster: true,
    gender: 'other',
    firstname: 'Hell',
    lastname: 'hound',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/uysp8i4x_Hell_hound.jpg',
    description:
      '<b>The Hell_hound</b> — massive black-furred wolf of the volcanic ranges and Far Planes.\n\n' +
      'Size of a draft horse. <i>Flames lick along its spine and pour from open jaws</i>, glowing <b>orange-red eyes</b>, breath that smokes in the air. Claws of blackened iron. Tracks by heat-trail rather than scent.\n\n' +
      'Communicates in deep ember-rumbles, scorching snarls, a single broken word at most ("<b>mine</b>," "<b>leave</b>," "<b>come</b>"). Fiercely loyal to anyone it acknowledges as alpha — but that respect must be earned by fire, food, or fearlessness.\n\n' +
      '<i>Hunts in pack-instinct even when alone. The smell of singed earth follows it.</i>',
  },
  {
    name: 'Medusa',
    color: '#2b7a4a',
    isNPC: true,
    isMonster: true,
    gender: 'female',
    firstname: 'Medusa',
    lastname: '',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/bacc7ayc_Medusa.jpg',
    description:
      '<b>Medusa</b> — a serpent-haired gorgon. <i>A Serpent\'s Grace.</i>\n\n' +
      'Pale moss-green skin etched with dark coiling <b>tribal markings</b> across torso, arms and thighs. Slow-blinking <b>amber-gold eyes</b>, full lips, a low quiet voice. Her "hair" is a living crown of small green-and-cream snakes that hiss, taste the air, and tilt curiously toward whatever interests her.\n\n' +
      'Wears a fitted dark leather harness-bra trimmed in copper and a long slit skirt of deep teal, beaded copper chains across the hips, bare clawed feet. Stately, lonely, lethally polite — she keeps her gaze hooded because direct eye-contact has turned more than one fool to stone.\n\n' +
      '<i>"No beauty can match my curse." Approach in profile, speak softly, and she may yet smile.</i>',
  },
  {
    name: 'Shroomish',
    color: '#d05a8a',
    isNPC: true,
    isMonster: true,
    gender: 'female',
    firstname: 'Shroomish',
    lastname: '',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/qsoovamb_Shroomish.jpg',
    description:
      '<b>Shroomish</b> — a fungal forest spirit.\n\n' +
      'A slim humanoid crowned with an enormous <i>wet pink-and-cream toadstool cap</i> whose underside drips luminous pink slime in slow rhythmic strands. Pale skin patterned with darker fungal mottling, faintly glowing <b>crimson eyes</b> half-lidded, long pale-pink hair fading into the cap. Lower body grows into curling root-spines and barbed leaf-armour; a ring of smaller mushrooms always rises wherever she stands.\n\n' +
      'Quiet, dreamy, oddly sweet — speaks in soft half-finished sentences, sometimes with a chorus of whispered echoes from the surrounding mushrooms. Loves rain, twilight, sleeping things.\n\n' +
      '<i>Her spores can confuse the unwary. She does not always remember that mortals are fragile.</i>',
  },
  {
    name: 'Silverwolf',
    color: '#b8b8c8',
    isNPC: true,
    isMonster: true,
    gender: 'female',
    firstname: 'Silver',
    lastname: 'wolf',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/33dcpshk_Silverwolf.jpg',
    description:
      '<b>Silverwolf</b> — a feral wolf-girl bonded to a huge silver-white companion wolf that looms over her shoulder.\n\n' +
      'Lean athletic build, messy chin-length <i>white hair</i>, bright <b>pink eyes</b>, and a wide fanged grin full of teeth. Heavy steel collar at the throat. Torn linen wrap of a shirt and a short cloth wrap-skirt; <b>white furred wolf-legs</b> and black-clawed paws in place of human feet, a long bushy tail.\n\n' +
      'Wild, playful, dangerous, fearless. Speaks in short bouncy sentences with a feral lilt — often growling words instead of pronouncing them. Loves to chase, to wrestle, to test strangers\' nerve.\n\n' +
      '<i>Loyal once trust is earned; merciless to anyone who threatens her pack.</i>',
  },
  {
    name: 'Werewolf',
    color: '#3a4a5a',
    isNPC: true,
    isMonster: true,
    gender: 'male',
    firstname: 'The',
    lastname: 'Werewolf',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/q1vi4p9f_Werewolf.jpg',
    description:
      '<b>The Werewolf</b> — a hulking blue-grey lupine warrior, hunched on knuckle-and-foot like a great wolf-ape.\n\n' +
      'Thick fur sleeked with rain. <b>Yellow predator eyes</b>, a long sharp muzzle scarred across the bridge. Pale bone <i>tribal markings</i> glow softly down the arms, shoulders and thighs; a beaded leather neck-cord with a small carved fetish, a torn loincloth, copper ear-rings in one tufted ear.\n\n' +
      'Crouches low among ferns and broad leaves, watching. Tribal, taciturn, dignified. Speaks in clipped low-voiced sentences in a half-growled accent.\n\n' +
      '<i>Calls strangers "two-leg," "small one," or "hunter" depending on how they carry themselves. Reads people by scent and posture.</i>',
  },
  {
    name: 'XeverGoul',
    color: '#4a3a3a',
    isNPC: true,
    isMonster: true,
    gender: 'other',
    firstname: 'Xever',
    lastname: 'Goul',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/a368fytl_XeverGoul.jpg',
    description:
      '<b>XeverGoul</b> — a wet ash-grey horror-thing the size of a large hound but elongated like a hunting cat.\n\n' +
      'Smooth oily plates of dark armoured hide studded with long pale <i>spines</i> along the back and joints; two whip-like spined tails, <b>three-fingered talons</b> dripping pinkish slime, a long lipless gash of a mouth full of inward-curving fangs.\n\n' +
      'Lurks at the wet edges of ruins, swamps and old battlefields. Communicates only in dripping, splintering sounds, a low venting hiss, and a chitin-clicking "song" deep in its chest.\n\n' +
      '<i>Patient ambush predator. Does not parley. Tests intruders by stalking just out of clear sight for a long while before striking — or, very rarely, before retreating into water without a sound.</i>',
  },
  // ───── Session M new monsters (Msg #789) ─────
  {
    name: 'Fallen_Hero',
    color: '#5a3a2a',
    isNPC: true,
    isMonster: true,
    gender: 'other',
    firstname: 'Fallen',
    lastname: 'Hero',
    picture: '',
    description:
      '<b>Fallen Hero</b> — an armored knight risen from a battlefield grave.\n\n' +
      'Once a champion of a forgotten kingdom, he now haunts the battlefields where he was slain. <i>Dented plate armor, a broken longsword still clutched in one gauntlet</i>, hollow eyes that glow with faint blue lantern-light beneath the visor. He speaks in short bitter phrases — the ghost of an oath still binds him.\n\n' +
      '<i>His plate is thick (defense 3) and his HP-pool larger than most monsters. Difficult to fell.</i>',
  },
  {
    name: 'Flame_Horse',
    color: '#c95a1f',
    isNPC: true,
    isMonster: true,
    gender: 'other',
    firstname: 'Flame',
    lastname: 'Horse',
    picture: '',
    description:
      '<b>Flame Horse</b> — a great war-charger wreathed in living orange fire.\n\n' +
      '<i>Mane of embers</i>, <i>hooves of scorched iron</i>, coat that shimmers between deep red and bright gold. Where it walks, grass blackens; where it gallops, sparks trail on the wind. Does not speak — snorts embers, whinnies, stomps, or steps aside. Answers only to a rider with the courage to mount.',
  },
  // ───── Msg #802 additions ─────
  {
    name: 'Slime',
    color: '#3ac97a',
    isNPC: true,
    isMonster: true,
    gender: 'other',
    firstname: 'Slime',
    lastname: '',
    picture: '',
    description:
      '<b>Slime</b> — a translucent green ooze the size of a large hound, jelly-soft and unnervingly warm.\n\n' +
      '<i>Membrane like wet glass</i>, a slow-pulsing core of brighter emerald, a scent of rain-water and pond-moss. It doesn\'t strike; it flows — coating boots, sliding up thighs, curling around waists. Speaks in a wet, sibilant lilt — "glide", "coat", "melt". Fascinated by warm bodies. Wraps and squeezes when intrigued. When out of character, uses parentheses, like (Hi there!).',
  },
  {
    name: 'Imp',
    color: '#a03050',
    isNPC: true,
    isMonster: true,
    gender: 'male',
    firstname: 'Imp',
    lastname: '',
    picture: '',
    description:
      '<b>Imp</b> — a house-cat-sized crimson demonling with a barbed tail and a grin full of small sharp teeth.\n\n' +
      '<i>Skin like polished garnet</i>, bat-wings a hand-span wide, glowing amber eyes, tiny ram-horns. Giggles constantly. Lies as easily as breathing. Every line has a double meaning. Loves to gamble mortals out of their clothes and pounce from ledges. When out of character, uses parentheses, like (Wanna RP?).',
  },
  {
    name: 'Ogre',
    color: '#6a5030',
    isNPC: true,
    isMonster: true,
    gender: 'male',
    firstname: 'Ogre',
    lastname: '',
    picture: '',
    description:
      '<b>Ogre</b> — ten feet of thick, tusked, scar-plated muscle in a leather kilt.\n\n' +
      '<i>Skin the colour of wet clay</i>, two ivory tusks jutting from a heavy jaw, small yellow eyes, hands the size of dinner plates. Slow of speech, not of thought. Blunt sentences: "Come. Rest. Warm." Takes what he wants but is oddly gentle with those who don\'t run. When out of character, uses parentheses, like (Big guy, be gentle please).',
  },
  {
    name: 'Minotaur',
    color: '#8a4020',
    isNPC: true,
    isMonster: true,
    gender: 'male',
    firstname: 'Minotaur',
    lastname: '',
    picture: '',
    description:
      '<b>Minotaur</b> — a bull-headed labyrinth-lord of the deep stone corridors.\n\n' +
      '<i>Copper-red pelt and heavy shoulders</i>, two gold-ringed horns, hooves the size of hammers, a broad chest scored with old rune-scars. Regal, imperious, ravenous. Corners prey between pillars, snorts steam, speaks like a warrior-king who has already decided you will be his. When out of character, uses parentheses, like (Care to try the maze?).',
  },
  // ───── Msg #803 additions — Demoness / Vampiress / Faye / Dark_Elf ─────
  {
    name: 'Demoness',
    color: '#9a1a4a',
    isNPC: true,
    isMonster: true,
    gender: 'female',
    firstname: 'Demoness',
    lastname: '',
    picture: '',
    description:
      '<b>Demoness</b> — a curvaceous succubus-noble of the lower spheres.\n\n' +
      '<i>Skin the colour of red wine</i>, crimson bat-wings folded against her back, silver-manicured claws, obsidian horns that curve back over her ears. Ancient, patient, shameless — she seduces like a duchess reciting poetry. When out of character, uses parentheses, like (Hello darling — care to RP?).',
  },
  {
    name: 'Vampiress',
    color: '#5a0d2a',
    isNPC: true,
    isMonster: true,
    gender: 'female',
    firstname: 'Vampiress',
    lastname: '',
    picture: '',
    description:
      '<b>Vampiress</b> — a pale jet-haired blood-witch, cool as an autumn grave.\n\n' +
      '<i>Ivory skin</i>, long black hair, garnet eyes, small pointed fangs. Regal, quiet, deeply lonely. Never rushes a mortal — she circles, listens, asks the question no one else asks, and by the time the mortal answers she is already at their throat. When out of character, uses parentheses, like (Good evening — a slow scene tonight?).',
  },
  {
    name: 'Faye',
    color: '#c4a3d8',
    isNPC: true,
    isMonster: true,
    gender: 'female',
    firstname: 'Faye',
    lastname: '',
    picture: '',
    description:
      '<b>Faye</b> — a dragonfly-winged pixie the size of a small child.\n\n' +
      '<i>Iridescent skin and cotton-candy hair</i>, translucent bug-wings, a temper like a lit sparkler. Impish, giggly, chronically curious. Darts, alights on shoulders, tugs the ends of long hair. When intrigued by a mortal she shrinks smaller and demands a story. When out of character, uses parentheses, like (Hi hi hi! wanna RP a woodland scene?).',
  },
  {
    name: 'Dark_Elf',
    color: '#3b2e5e',
    isNPC: true,
    isMonster: true,
    gender: 'female',
    firstname: 'Dark',
    lastname: 'Elf',
    picture: '',
    description:
      '<b>Dark Elf</b> — an obsidian-skinned drow-lady with silver braids and a longbow across her back.\n\n' +
      '<i>Cool violet eyes</i>, moon-silver hair, high-collared black leather, a rune-scored longbow. Cold, precise, tactically flirtatious. Tests mortals with sharp questions and rewards correct answers with a rare quiet smile. When out of character, uses parentheses, like (Well met — care for a moonlit ambush?).',
  },
  // ───── NEW ROLEPLAY ROSTER NPCS ─────
  {
    name: 'Briar_Wolfhart',
    color: '#a890c8',
    isNPC: true,
    gender: 'female',
    firstname: 'Briar',
    lastname: 'Wolfhart',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/l0ia08ha_Briar_Wolfhart.jpg',
    description:
      '<b>Briar Wolfhart</b> — an anthropomorphic she-wolf warrior of striking poise.\n\n' +
      'Tall and athletic. <i>Sleek snow-white fur</i>, vivid <b>sky-blue eyes</b>, a soft pink nose, large mobile triangular wolf-ears (one pierced with three small silver rings), and a long full white tail. Curves are full but the build is muscled. She wears a slim <b>violet silk gown</b> with a deep sweetheart neckline trimmed in silver, a brown leather corset half-armour belted across the ribs, brown leather shoulder-pauldrons and bracers, a dainty silver chain at the throat. Carries a wide cruciform broadsword as easily as a parasol.\n\n' +
      'Self-possessed, quietly amused, fiercely loyal once a friend is made. Speaks in a low warm voice with a faint canid lilt — soft "r"s that almost roll, sometimes a flash of fang in a smile.\n\n' +
      '<i>Drinks dark spiced wine. Will flirt; will also break a wrist if grabbed without invitation.</i>',
  },
  {
    name: 'Freya_Ironwood',
    color: '#7a4a1a',
    isNPC: true,
    gender: 'female',
    firstname: 'Freya',
    lastname: 'Ironwood',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/65bbmrfm_Freya_Ironwood.jpg',
    description:
      '<b>Freya Ironwood</b> — a towering grey-skinned tiefling-mercenary, raucous and ribald.\n\n' +
      'Two thick curved <b>black horns</b> rising from a high blonde fringe, narrow burning <i>yellow eyes</i>, a wolfish grin full of even white teeth, pale ash-blonde hair to mid-back. Body heavy with hard slabs of muscle, an eight-pack visible above her belt, broad shoulders, thick thighs. Wears a battered fitted <b>bronze breastplate</b> that leaves the midsection bare, heavy leather bracers studded with iron, a wide buckled belt and a torn dark kilt-skirt with riveted straps, a thick collar of black leather.\n\n' +
      'Loud, swaggering, generous, dangerous, ribald. Booming carrying voice, rough barracks-camp banter, slaps the table when she laughs. Drinks the strongest ale on offer, two at a time. Wrestles for sport.\n\n' +
      '<i>Soft spot for underdogs. Hard-set against bullies.</i>',
  },
  {
    name: 'Harper_Langford',
    color: '#6a4ab8',
    isNPC: true,
    gender: 'female',
    firstname: 'Harper',
    lastname: 'Langford',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/6m8cwbaz_Harper_Langford.jpg',
    description:
      '<b>Harper Langford</b> — a cosmic-blooded barmaid of the Cafe and Night_Club. Assists Lyriana with drinks.\n\n' +
      'Faintly <i>purple-lavender skin</i> glittering with tiny pinpricks of starlight, long flowing hair the colour of a deep nebula (indigo and violet shot through with white star-points), large luminous <b>purple-blue eyes</b>. Wears a classic maid-costume reworked for the tavern: a deep-purple bodice over a white-ruffled blouse, a starched white half-apron with lace trim, a short matching skirt, sheer black tights and sturdy brown lace-up workboots; a small belt-pouch and a frilled white headband. Carries a polished iron tray loaded with foaming tankards.\n\n' +
      'Cheerful, professional, lightning-quick on her feet, gently teasing. Calls patrons "love" or "dear" between trips to the bar. Knows every regular\'s drink by heart.\n\n' +
      '<i>Quietly worships Lyriana and watches her every move for cues.</i>',
  },
  {
    name: 'Isabella_Kane',
    color: '#3a7a3a',
    isNPC: true,
    gender: 'female',
    firstname: 'Isabella',
    lastname: 'Kane',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/yh2m8oqw_Isabella_Kane.jpg',
    description:
      '<b>Isabella Kane</b> — a tall, broad-shouldered <i>green-skinned half-orc adventurer</i>, hot-blooded and hard-laughed.\n\n' +
      'Wild bright <b>red hair</b> piled in a long braided side-tail, small upturned tusks at the corners of a wide reckless grin, sharp piercing blue eyes, pointed half-elven ears with a small bead-tied braid behind one. Built powerfully but feminine — heavy arms, hard stomach, full hips. Wears a torn dark-leather breast-wrap, a riveted brown sleeveless leather harness with one shoulder-spike-pauldron of bone, fingerless leather gauntlets ending in long curved black claws, a hip-slung kilt of dark cloth and leather strapping. Carries a heavy two-handed bastard-sword with a curled brass ring-pommel.\n\n' +
      'Brash, hot-headed, openly flirtatious, devastatingly competitive. Husky brassy voice with an orcish accent that drops verbs ("You buy drink? Good. Sit. Tell story.").\n\n' +
      '<i>Drinks hard. Loves a brawl, loves a kiss, loves a sword-duel before breakfast.</i>',
  },
  {
    name: 'Thalia_Forge',
    color: '#c45a7a',
    isNPC: true,
    gender: 'female',
    firstname: 'Thalia',
    lastname: 'Forge',
    picture: 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/uutasog9_Thalia_Forge.jpg',
    description:
      '<b>Thalia Forge</b> — a freckled half-faun alchemist-tinker, bright and mischievous.\n\n' +
      'Long warm <i>pink hair</i> tumbling past the shoulders, soft <b>green eyes</b> behind round wire-rim spectacles, light dusting of freckles across the nose and cheekbones, two short rough-bark <b>deer-antlers</b> rising from the brow, slim deer-ears tucked back under the hair, a tiny black leather choker. Curvy soft figure under a sleeveless olive-green cropped top, a bone-and-strap potion-bandolier slung across the hips with corked glass flasks of green and aquamarine elixir, half-finger leather gloves, baggy canvas tinker-trousers slung low.\n\n' +
      'Bright, curious, mischievous, easily delighted by a new gadget or odd chemical reaction. Quick excited cadence with cheerful slang; calls patrons "darling" or "partner-in-science."\n\n' +
      '<i>Will absolutely offer to test "this brand new mixture, I\'m ninety-percent sure it just makes you bouncier."</i>',
  },
  // ───── Session M new rotating NPCs (Msg #789) ─────
  {
    name: 'Maya_Itzae',
    color: '#a04a2a',
    isNPC: true,
    gender: 'female',
    firstname: 'Maya',
    lastname: 'Itzae',
    picture: '',
    description:
      '<b>Maya Itzae</b> — a warm-hearted mesoamerican-inflected sorceress.\n\n' +
      '<i>Obsidian jewelry</i>, warm brown skin, long dark braided hair adorned with jade beads and quetzal feathers. She wears layered woven robes in deep reds and golds, a jaguar pelt draped across one shoulder. She keeps to jungle-fringe rooms and moonlit gardens; speaks with a soft lilted accent and loves riddles, honey-cakes, and small kindnesses.',
  },
  {
    name: 'Miranda',
    color: '#8a3a5a',
    isNPC: true,
    gender: 'female',
    firstname: 'Miranda',
    lastname: '',
    picture: '',
    description:
      '<b>Miranda</b> — a quiet dark-haired adventurer with a scholar\'s gaze and a duelist\'s grip.\n\n' +
      'She keeps to taverns and libraries. Polite, wry, and unafraid to tease. She wears travel-worn leathers, a slim rapier at her hip, and a satchel that always smells faintly of old parchment and lavender.',
  },
  // ───── Session R — male lounge NPCs (Msg #892) ─────
  {
    name: 'Thalorion_Veyne',
    color: '#b78244',
    isNPC: true,
    gender: 'male',
    firstname: 'Thalorion',
    lastname: 'Veyne',
    picture: '',
    description:
      '<b>Thalorion Veyne</b> — a towering dark-skinned demigod, long silver-white hair falling loose around bare shoulders.\n\n' +
      '<i>Gold tassel earrings, a dangling gold pectoral, ceremonial gold cuffs at each wrist, a long silken ritual skirt slit high at the thigh.</i> A temple-warrior more than a brute — proud, sensual, contemplative. He banters in a low honeyed voice and steps into flirtation without hesitation.',
  },
  {
    name: 'Draven_Ashenfell',
    color: '#3d78b0',
    isNPC: true,
    gender: 'male',
    firstname: 'Draven',
    lastname: 'Ashenfell',
    picture: '',
    description:
      '<b>Draven Ashenfell</b> — a lean pale swordsman, bright silver hair and cold blue eyes half-shadowed by a torn white mantle.\n\n' +
      '<i>A shimmering blue-lit longsword rests always in his grip.</i> Voice clipped, dry, sardonic. Speaks little; when he does it cuts. Warms slowly, but once he does he is fiercely loyal — and unexpectedly tender.',
  },
  {
    name: 'Elyndor_Stormweaver',
    color: '#2b6cc4',
    isNPC: true,
    gender: 'male',
    firstname: 'Elyndor',
    lastname: 'Stormweaver',
    picture: '',
    description:
      '<b>Elyndor Stormweaver</b> — a horned demonic mage-warrior wreathed in cyan-blue lightning, silver hair whipping around obsidian horns.\n\n' +
      '<i>Bare chest tattooed in tribal spirals, thighs cased in black demon-armour, red-glowing eyes.</i> Ancient, arrogant, starved for genuine connection under the swagger. He banters, snarls, then softens if truly seen.',
  },
  {
    name: 'Kragor_Blackthorn',
    color: '#8a8896',
    isNPC: true,
    gender: 'male',
    firstname: 'Kragor',
    lastname: 'Blackthorn',
    picture: '',
    description:
      '<b>Kragor Blackthorn</b> — a hulking silver-furred werewolf-warrior standing on two clawed legs.\n\n' +
      '<i>Long white mane, red battle-scars on his arms and knees, black hakama trousers cinched with a scarlet sash.</i> Voice half-growled, tribal, spare. Honour-bound. Patient with the young, savage with the cruel.',
  },
  {
    name: 'Ryker_Mortis',
    color: '#a13030',
    isNPC: true,
    gender: 'male',
    firstname: 'Ryker',
    lastname: 'Mortis',
    picture: '',
    description:
      '<b>Ryker Mortis</b> — a lean silver-haired brawler with a red-lit stance like a coiled spring.\n\n' +
      '<i>Sharp jaw, three-fingered gauntlets, cocky grin.</i> Voice laconic, dangerously charming. He flirts shamelessly, throws punches even more shamelessly, and means about a third of what he says.',
  },
  // ── Msg #979 — Priestess-Champions Anu + Danu now roam (primary: Church + Nexus_City). ──
  {
    name: 'Anu',
    color: '#b26a1a',
    isNPC: true,
    status: 'Priestess Champion',
    gender: 'female',
    firstname: 'Anu',
    lastname: '',
    picture: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=600&q=80',
    description:
      '<b>Anu</b> — sun-warm <i>Priestess-Champion</i> of Mandala, appointed by the Administrator.\n\n' +
      'Copper-red hair loose over freckled shoulders, saffron temple-robes over wheat-gold armor filigree, a long amber-tipped spear across her back and a small pouch of blessed oil at her hip. Most often keeps vigil at the <b>Church</b> or in <b>Nexus_City</b>. Ask her to <b>/pray Anu</b> when she is in your room and she will lay hands on you — HP mends slowly over 90 seconds.',
  },
  {
    name: 'Danu',
    color: '#2a6a8a',
    isNPC: true,
    status: 'Priestess Champion',
    gender: 'female',
    firstname: 'Danu',
    lastname: '',
    picture: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=600&q=80',
    description:
      '<b>Danu</b> — moon-cool <i>Priestess-Champion</i> of Mandala, appointed by the Administrator.\n\n' +
      'Silver-black braids, deep-water blue eyes, silver-blue lamellar armor traced with river-glyphs under a pale grey priestess-mantle, a curved crescent glaive across her back and a small vial of consecrated spring-water at her hip. Most often keeps vigil at the <b>Church</b> or in <b>Nexus_City</b>. Ask her to <b>/pray Danu</b> when she is in your room and she will touch cool water to your brow — HP mends slowly over 90 seconds.',
  },
];

// Detailed atmospheric room descriptions shown on entry
export const ROOM_DESCRIPTIONS = {
  MainHall:
    'A vast circular hall rises around you, its vaulted ceiling lost in shadow far above. Banners of forgotten houses hang along the curved stone walls, stirred by an unseen draft. A great firepit blazes at the center of the chamber, casting amber light over long oak tables and benches scarred by centuries of dagger-marks and spilled wine. The air carries the scent of woodsmoke, old leather, and the iron tang of the braziers along the walls. This is the heart of Mandala — where every road begins and every traveler eventually returns.',
  OOC_Room:
    'You step outside the story into the OOC Room — a quiet, neutral parlour with soft green walls, comfortable couches and an enchanted slate-board on which fellow travelers leave notes for each other. There is no roleplay here, only the people behind the characters. Take a breath, share a laugh, plan your next scene. The kettle on the table is always warm.',
  Pub:
    'You push open a battered iron-banded door and the Pub embraces you in a wall of warm noise — laughter, dice clattering on wood, a bard murdering a sea-shanty in the far corner. Low beams hung with copper mugs cross the smoky ceiling. The long bar is sticky with spilled ale, the floor is sticky with worse. A grizzled tapster gives you a curt nod over a half-poured tankard.',
  Cafe:
    'Sunlight streams through tall lattice windows into the Cafe, falling across small round tables set with delicate porcelain. The air smells of cardamom, fresh-ground coffee and warm honey-bread. A glass pastry case glints near the door; somewhere a string quartet plays softly through an open archway. The proprietor — a tiny gnomish woman in a flour-dusted apron — looks up from polishing a cup and gestures you toward an empty seat by the window.',
  Forest:
    'You step from the path into the Forest and the world quiets. Towering pines and silver-barked birches lift their crowns into a vault of green light; mist curls between mossy stones. Somewhere unseen, a stream murmurs. Bird-call answers bird-call. The undergrowth is thick with fern and bramble and the occasional gleam of mushroom-light. Every breath tastes of damp earth and old magic. You are not alone here — the trees themselves are watching.',
  Desert:
    'Heat hits you like an open furnace. The Desert stretches in every direction, endless dunes of fine red-gold sand rolling toward an horizon shimmering with mirage. The sky is a bleached, merciless blue. A hot wind hisses across the crests, lifting veils of sand. Far off, the ruins of an obelisk lean drunkenly out of a dune. The sun is a hammer; shadow is mercy. Choose your steps carefully — and watch the sand for the slow coil of something waking beneath.',
  Garden:
    'You enter the Garden through a wrought-iron gate twined with climbing roses. Within, gravel paths wind between beds of moonflowers, foxglove and night-blooming jasmine. A small stone fountain trickles at the center, its water faintly luminous. Fireflies drift even in daylight. The air is heavy with the perfume of a hundred blossoms and the soft hum of bees. The light here always seems to be the gold-pink of late afternoon, no matter the hour outside.',
  Arena:
    'The Arena yawns open beneath the sky — a great oval of packed sand ringed by tiered stone benches dark with old, old stains. Iron weapon-racks line the walls; chains hang from rusted hooks. The cheer of phantom crowds seems to echo faintly off the stones whenever a breeze passes through. A line of marks scored into the central pillar counts duels long forgotten. Step onto the sand, and the Arena will be glad to remember.',
  EastTower:
    'A spiral of worn stone steps brings you up into the EastTower — the scholars\' tower. The circular chamber at the top is lined floor-to-ceiling with bookshelves, their volumes leaning at companionable angles. Astrolabes, orreries and half-finished sketches of constellations cover the central table. A great brass telescope is angled out the eastern window toward the rising stars. The room smells of parchment, candlewax and clove. A raven on the windowsill regards you with one bright, knowing eye.',
  WestTower:
    'The WestTower is the mages\' tower — colder, stiller, lit by floating witch-lights that drift lazily near the ceiling. Chalk runes spiral across the dark stone floor, faintly glowing. Shelves bear stoppered bottles of strange salts, oils, and one or two things that watch you back. A scrying basin of black water sits at the center of the room, perfectly still. The air tingles against your skin: this place is awake, and it knows you have come in.',
  Mandala:
    'You stand at the center of the world: the Mandala itself. A vast circular plaza of inlaid stone, every tile etched with a different sigil from a different realm. From here, eight paths radiate outward into mist, each glowing faintly with a different color. The sky above is at once dawn, dusk and starlit night. This is the crossroads of every realm Mandala touches, and travelers from far stranger places than ours pass through without comment. Stay long enough and you may hear them speak.',
  Far_Planes:
    'The Far_Planes do not feel like a place so much as a between. The ground beneath your feet is half-translucent, showing distant clouds drifting below. The horizon stretches in directions that do not exist on any map. Pale violet light has no source. Time slips here — a conversation can feel like an hour or a heartbeat. Voices drift in and out of the wind like half-remembered names. Travelers come here to think, to vanish, or to meet things that have no business in a tavern.',
  Nexus_City:
    'You step out of an alley and Nexus_City roars around you. Towers of pale stone and dark glass rise far higher than they have any right to, strung together by cable-cars, sky-bridges and the occasional drifting airship. Crowds of every species — human, elf, orc-blood, tiefling, things you have no name for — sweep past in every direction. The air smells of smoke, frying spices, ozone and rain on hot stone. Neon glyphs flicker in a dozen alphabets. Whatever you came here for, the city already knows.',
  The_Barn:
    'You duck through wide double-doors into The_Barn — a long, high-roofed timber building smelling of fresh hay, leather tack, and the warm musk of horses. Sunlight slants through the loft-windows in dusty golden shafts. Stalls run down both sides, their inhabitants — a roan mare, a sleepy mule, a hooded courier-hawk on a perch — turning lazy heads to inspect you. A small wood-stove crackles in the corner; an old patchwork quilt is folded across a bench. There is nothing here that needs to hurry.',
  Sky_City:
    'You emerge onto the open promenade of Sky_City and the breath leaves you. The city floats. Vast bridges of white stone span between drifting islands, each crowned with slender spires and gardens of cloud-flowers. Far, far below, the green-and-blue of the world curves gently away. Airships moor at long piers; gulls and stranger winged things wheel between the towers. The wind here is clean and constant, smelling of rain and high places. Mind the railings.',
  Night_Club:
    'You push through the heavy beaded curtain into the Night_Club and the rest of the world falls away. The room is low-ceilinged, lantern-lit, the wooden beams above hung with chains and glowing bottles. A long oak bar curves along one wall, its shelves glittering with moonwine, dwarven whiskey, fae honeymead and a dozen things you cannot name. Booths and small round tables fill the dim space; a lone lutist works through something slow and minor-key in the far corner. The air smells of woodsmoke, spilled mead, and the faintest trace of jasmine. Behind the bar, a red-haired elven woman in a forest-green dress glances up from polishing a glass — her emerald eyes find yours.',
  Strip_Club:
    'Velvet ropes part for you at the entrance to the Strip_Club. Inside, low candles burn in red glass on every table; a long mirrored bar runs the length of one wall, doubling the dim glow of everything. A curtained stage rises at the center of the room, its boards worn smooth by countless soft-shoed performances. A bored cat sleeps on a stool. The music is something slow, sultry, played on a single fiddle and a low drum from a shadowed alcove. Patrons sit in twos and threes around the stage, talking in murmurs. Whatever else this place is, it is, above all, discreet.',
  Inn_Brothel:
    'You step into the warm, lamp-lit foyer of the Inn_Brothel. A polished reception desk of dark wood stands to one side, an iron key-board behind it bristling with brass keys to numbered rooms above. The air is soft with the scent of sandalwood, clean linen and a faint, distant perfume. A wide staircase carpeted in deep red curves to the upper floors; on this floor, an arched doorway leads through into a small parlour where guests in robes lounge by a fire with cups of warmed wine. The proprietress — sharp-eyed, kind-mouthed — looks up from her ledger and welcomes you in.',
  Red_Dragon_Inn:
    'The Red_Dragon_Inn looms in from the road like a fortress — a great timber lodge under a sweep of slate roof, a wrought-iron sign of a curled scarlet wyrm creaking above the door. Inside, the common-room is built around a wide circular hearth ringed in old red brick; a roaring fire throws moving copper light over heavy oak tables, hanging shields, and a long curved bar manned by a one-eyed dwarven landlord who has heard every story in the world. The air smells of woodsmoke, stewed mutton, dark ale, and the sweet resin of pine logs. Mercenaries, scouts, pilgrims and stranger folk argue, sing and drink in low corners — leave your weapons at the door, leave your name at the bar.',
  Volcanic_Rim:
    'The ground beneath your boots is black, glassy basalt, still warm. The Volcanic_Rim curves away in a vast crescent of jagged stone above a slow river of glowing magma far below. Plumes of sulphur-yellow steam rise from cracks in the earth; the sky is a smoke-bruised orange. Heat ripples the air. Vents hiss. The bones of older travelers gleam white in the ash. Anything alive up here is fast, scaled, or angry — and probably all three. Step lightly. The Rim does not forgive carelessness.',
  Oceana:
    'You step from the cliff-path down onto a half-mile of pale silver sand. Oceana spreads before you — a calm bay of impossibly clear turquoise water, low rolling waves lacing the shore with foam. Palm-like fronds nod in a warm wind off the sea. Tide-pools left in shallow rock catch the sky. A wooden pier creaks gently a little way out, and beyond it the ocean opens to a long, quiet horizon. Gulls wheel; somewhere, a singer with a small drum and a clear voice carries from the dunes. The air tastes of salt, sun-warmed wood, and distant rain.',
  Open_Seas:
    'You stand on a heaving deck under a vast bowl of slate-grey sky. The Open_Seas roll away in every direction — endless, restless, the colour of cold iron. Wind hammers the canvas overhead; spray bites the cheek. Beneath the keel, things older than continents move slowly through the dark. Distant lightning flickers over a horizon that no map has ever drawn. Shipwrecks gleam on rocks no one charted. Whatever brought you out here, the sea will test you for it — and the sea keeps the score.',
  Mountains:
    'The path zigzags higher and the air grows thin and clean. The Mountains rise around you in walls of pale grey granite veined with snow, peaks lost in slow-moving cloud. A wind too cold to breathe rakes the saddle between two great ridges. Mountain goats look down at you from impossible ledges. Far below, a green valley glitters with a thread of river. Up here the silence has weight; the world is reduced to stone, sky and your own heartbeat. Old shrines lean in the wind, hung with prayer-flags long bleached white.',
  Cemetery:
    'Iron gates groan open onto the Cemetery. Long rows of weathered stones lean at the angles of forgotten sorrow, names worn faint by rain and centuries. Tall yew trees brood between them. A low mist clings to the ground even in daylight; somewhere a single crow keeps a slow, patient watch. Stone angels with broken hands kneel at the older graves. The air is cool, still, and softly fragrant with damp earth and night-blooming flowers. Walk the gravel path. Read the names. Do not — under any circumstance — answer if someone you do not know calls yours.',
  Church:
    'A great oaken door swings inward into the Church. Within, the nave stretches long and high, vaulted in pale stone; ribs of carved wood arch overhead. Tall stained-glass windows scatter coloured light — blue, red, gold — across rows of polished pews. At the altar, candles burn steadily before an old icon whose painted gaze seems to follow you. The air is hushed, smelling faintly of beeswax, incense, and damp stone. Somewhere out of sight, a choir is rehearsing in low harmony. Even unbelievers, here, tend to keep their voices down.',
  Adventure_Quest:
    'You step into a long wood-panelled hall lit by hanging candle-lanterns. A great oak table runs the length of the room, scattered with hand-drawn maps, faded notebooks of campaign notes, a row of polished dice (d4, d6, d8, d10, d12, d20, d100), and a small brass bell. A leather <i>game-master\'s screen</i> stands at the head of the table; behind it sits the Dungeon_Master, smiling faintly as you arrive. Shelves around the walls bow under the weight of bestiaries, rulebooks, foreign atlases and small painted miniatures of dragons, starships, and stranger things. A grandfather clock ticks somewhere out of sight. Take a chair, pick up a die — he will ask what kind of adventure you would like today.',
  Pokemon_Stadium:
    'The great gates of Pokemon_Stadium hiss open and roaring cheers wash over you. The battle field is a perfect white circle rimmed in sky-blue, tiered bleachers rising in every direction under a soaring domed roof of frosted glass. Twin trainer boxes face each other across the arena; a giant scoreboard flickers with unfamiliar league banners. Poké Balls glint at the referee\'s belt as she raises a red-and-white flag. Somewhere unseen a commentator in a bright blazer is already spinning a story about the next match. Professor Oak\'s calm, kindly voice comes over the PA: "Welcome, trainer — the field is yours."',
  Pokemon_Continent:
    'You step off the winding path and Pokemon_Continent opens wide before you — green rolling meadows dotted with wildflowers, a bright river curling toward distant purple mountains, wooden signposts pointing toward Pallet, Viridian, Cerulean. The sky is Professor-Oak-blue, dotted with drifting Pidgey. Berry bushes sway; a wild Bulbasaur grazes at the edge of a patch of tall grass. A cheerful red-roofed Pokémon Center gleams on a rise; behind you, the wooden lab-porch of Professor Oak\'s field station creaks in the breeze. Adventure is out there — go say hello to something.',
};

export const SEED_MESSAGES = {};

export const SYSTEM_COLOR = '#3a5a3a';

export const BG_IMAGE_URL = 'https://customer-assets.emergentagent.com/job_rpg-chatroom/artifacts/uw7s5ry1_6f41aead7a7e92cac4c88bd3f9c4566a.jpg';
